export default "__VITE_ASSET__BwMp8foY__"